<template>
  <div>
    <h2>Edit Sample:</h2>

    <div class="sample-selector">
      <div class="input">
        <label class="input-label">Variety</label>
        <multiselect
          class="selectbox"
          selectLabel=""
          v-model="variety"
          :options="varietyOptions"
          label="label" />
      </div>
      <div class="input">
        <label class="input-label">Location</label>
        <multiselect
          class="selectbox"
          selectLabel=""
          v-model="location"
          :options="locationOptions"
          label="label" />
      </div>
      <div class="input">
        <label class="input-label">Date</label>
        <datepicker
          v-model="sampleDate"
          format="yyyy-MM-dd"
          input-class="sample-date"
          />
      </div>
    </div>
    <table>
      <tr>
        <th>Number</th>
        <th>Skin Tannin</th>
        <th>Seed Tannin</th>
        <th>Seeds/Berry</th>
        <th>Fresh Berry Weight (g)</th>
      </tr>
      <tr v-for="sample in samples" :key="sample.id">
        <td>{{ sample.num }}</td>
        <td>
          <input v-model="sample.skin_tannin" class="entry-box" type="number" step="0.1" />
        </td>
        <td>
          <input v-model="sample.seed_tannin" class="entry-box" type="number" step="0.1" />
        </td>
        <td>
          <input v-model="sample.seeds_per_berry" class="entry-box" type="number" step="0.1" />
        </td>
        <td>
          <input v-model="sample.berry_weight" class="entry-box" type="number" step="0.01" />
        </td>
      </tr>
    </table>
    <button class="red-button" @click="save()">Save All Samples</button>
    <br /><br />
    Here, you can paste in four columns from Excel (Skin Tannin, Seed Tannin, Seeds/Berry,
    Fresh Berry Weight.
    <textarea v-model="excel" placeholder="Paste new data from Excel here..."></textarea>
    <button class="red-button" @click="importExcel()">Copy To Above Cells</button>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'EditSample',
  components: {
    Multiselect,
    Datepicker,
  },
  props: ['user_id', 'date', 'loc_id', 'var_id'],
  created() {
    this.$store.dispatch('getVarieties');
    this.$store.dispatch('getLocationsAll');
  },
  data() {
    return {
      moment,
      user: {},
      samples: [],
      variety: { label: this.varietyLabel(this.var_id), value: this.var_id },
      location: { label: this.locationLabel(this.loc_id), value: this.loc_id },
      sampleDate: new Date(),
      excel: '1\t2\t3\t4\n' +
      '5\t6\t7\t8\n' +
      '9\t10\t11\t12\n',
    };
  },
  mounted() {
    if (this.user_id) {
      axios.get(`users/${this.user_id}`)
        .then((res) => {
          this.user = res.data;
          if (this.user.locations[0]) {
            const locId = this.user.locations[0].id;
            this.location = { label: this.locationLabel(locId), value: locId };
          }
        }).catch((err) => {
          console.log(err);
        });
    }
    this.sampleDate = moment(this.date).toDate();
    this.loadSample();
  },
  methods: {
    loadSample() {
      const app = this;
      if (!app.loc_id) {
        for (let i = 1; i <= 9; i++) {
          app.samples.push({
            num: i,
            loc_id: null,
            var_id: null,
            sample_date: null,
            skin_tannin: null,
            seed_tannin: null,
            seeds_per_berry: null,
            berry_weight: null,
          });
        }
        return;
      }
      axios.get(`samples-raw/${app.loc_id}/${app.var_id}/${app.date}`)
        .then((resp) => {
          app.samples = resp.data;
          // console.log(app.samples.length);
          while (app.samples.length < 9) {
            app.samples.push({
              num: app.samples.length + 1,
              loc_id: app.loc_id,
              var_id: app.var_id,
              sample_date: app.date,
              skin_tannin: null,
              seed_tannin: null,
              seeds_per_berry: null,
              berry_weight: null,
            });
          }
        })
        .catch((resp) => {
          console.error(resp);
          alert('Problem!');
        });
    },
    save() {
      const app = this;
      if (!app.variety.value) {
        alert('You must select a Variety.');
        return;
      }
      if (!app.location.value) {
        alert('You must select a Location.');
        return;
      }
      app.samples.forEach((sample, index, samples) => {
        app.samples[index].var_id = app.variety.value;
        app.samples[index].loc_id = app.location.value;
        app.samples[index].sample_date = this.moment(app.sampleDate).format('YYYY-MM-DD');
      });
      axios({ url: `samples-raw-array`, method: 'POST', data: this.samples })
        .then((resp) => {
          // console.log(resp.data);
          this.loadSample(); // Reload the sample to acquire newly created IDs
          alert('Saved the samples.');
        })
        .catch((resp) => {
          // console.log(resp);
          alert('Error: there was a problem saving the samples.');
        });
    },
    importExcel() {
      const app = this;
      const lines = this.excel.split('\n');
      let i = 0;
      lines.forEach((line) => {
        const lineTrim = line.trim();
        const cols = lineTrim.split('\t');
        if (cols.length === 4) {
          if (app.samples[i]) {
            app.samples[i].skin_tannin = cols[0];
            app.samples[i].seed_tannin = cols[1];
            app.samples[i].seeds_per_berry = cols[2];
            app.samples[i].berry_weight = cols[3];
          }
          i += 1;
        }
      });
      // console.log();
    },
    varietyLabel(idIn) {
      const id = parseInt(idIn);
      const results = this.$store.state.varieties.filter(item => item.id === id);
      if (results.length > 0) {
        return results[0].name;
      }
      return '';
    },
    locationLabel(idIn) {
      const id = parseInt(idIn);
      const results = this.$store.state.locationsAll.filter(item => item.id === id);
      if (results.length > 0) {
        return results[0].name;
      }
      return '';
    },
  },
  computed: {
    varietyOptions() {
      const options = [];
      this.$store.state.varieties.forEach((variety) => {
        options.push({ label: variety.name, value: variety.id });
      });
      return options;
    },
    locationOptions() {
      const options = [];
      this.$store.state.locationsAll.forEach((location) => {
        options.push({ label: location.name, value: location.id });
      });
      return options;
    },
  },
};
</script>
<style>
  input.sample-date {
    padding: 9px;
    width: 120px;
  }
</style>
<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';
  @import '../assets/_common.scss';

  .sample-selector {
    background: #3b3b3b;
    margin-top: .5rem;
    padding:  .5rem .5rem 1rem .5rem;
    display: flex;
    width: 500px;
  }
  
  .input{
    flex: 1;
    padding: 0 .5rem;
    display: flex;
    flex-direction: column;
  }

  .input-label{
    margin-bottom: .25rem;
  }
  
  textarea {
    margin-top: 5px;
    width: 100%;
    height: 200px;
  }
  .entry-box {
    padding: 3px;
    width: 70px;
  }
    
  label.input-label {
    color: #D8D8D8
  }
</style>



// WEBPACK FOOTER //
// src/pages/EditSample.vue